import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=6824dd7a&scoped=true&lang=pug&"
import script from "./blank.vue?vue&type=script&lang=js&"
export * from "./blank.vue?vue&type=script&lang=js&"
import style0 from "./blank.vue?vue&type=style&index=0&id=6824dd7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6824dd7a",
  null
  
)

export default component.exports